const getFullAudioUrl = (url: string, apiUrl: string) =>
  `${process.env.NEXT_PUBLIC_POLYAI_API}/${apiUrl}/${url}`;

export default getFullAudioUrl;
